import { Star } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "Renee re-shopped our home and auto after a big renewal hike. Better coverage, lower premium, and she explained every line.",
    name: "The Harrisons",
    meta: "Grant Park · Home & Auto",
  },
  {
    quote:
      "She sat with my mother for over an hour walking through Medicaid. Patient, kind, and she followed up twice after. Rare these days.",
    name: "Denise W.",
    meta: "Decatur · Medicaid",
  },
  {
    quote:
      "Life insurance felt overwhelming until Renee broke it into three simple options. My kids are protected now, and I finally understand my own policy.",
    name: "Marcus T.",
    meta: "Atlanta · Life & Health",
  },
];

const Stars = () => (
  <span className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={14} className="fill-[color:var(--ns-gold)] text-[color:var(--ns-gold)]" />
    ))}
  </span>
);

export const Testimonials = () => (
  <section id="stories" data-testid="testimonials-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
      <Reveal>
        <Eyebrow testId="testimonials-eyebrow">Client stories</Eyebrow>
        <h2
          data-testid="testimonials-heading"
          className="max-w-2xl font-serif text-2xl tracking-tight text-[color:var(--ns-ink)] sm:text-3xl lg:text-4xl"
        >
          Neighbors who found <em className="text-[color:var(--ns-gold)]">their way.</em>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={0.1 * i}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="spotlight-card flex h-full flex-col rounded-3xl p-8"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 font-serif text-lg italic leading-relaxed text-[color:var(--ns-ink)]/90">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7">
                <p className="font-semibold text-[color:var(--ns-ink)]">{t.name}</p>
                <p className="mt-1 font-mono text-xs uppercase tracking-[0.18em] text-[color:var(--ns-muted)]">
                  {t.meta}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
